import { useEffect } from "react";

/**
 * Crisp Chat widget — live chat (human support).
 * Production: set CRISP_WEBSITE_ID in deployment or secret; injected at runtime via config.js.
 * Local dev: set REACT_APP_CRISP_WEBSITE_ID in .env.
 * Get your Website ID: Crisp Dashboard → Settings → Setup & Integrations.
 */
export default function CrispChat() {
  useEffect(() => {
    const websiteId =
      (typeof window !== "undefined" && window.__ENV__?.REACT_APP_CRISP_WEBSITE_ID) ||
      process.env.REACT_APP_CRISP_WEBSITE_ID ||
      "";
    if (!websiteId || websiteId.trim() === "") return;

    if (window.$crisp) return; // Already loaded

    window.$crisp = [];
    window.CRISP_WEBSITE_ID = websiteId;
    const script = document.createElement("script");
    script.src = "https://client.crisp.chat/l.js";
    script.async = 1;
    document.getElementsByTagName("head")[0].appendChild(script);
  }, []);

  return null;
}
